import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Alert } from 'react-native';
const debug = require('debug')('se:pushNotificationSlice');

import { RootState } from './rootReducer';

interface PushNotificationNotification {
  ios?: any;
  title: string;
  sound?: string;
  body?: string;
}

interface PushNotificationData {
  body: string;
  push_id: string;
  advert_id?: string;
  category_name?: string;
  screen?: string;
  title?: string;
  push_campaign_id?: string;
  content_id?: string;
  target?: string;
}

export interface PushNotification {
  messageId?: string;
  data: PushNotificationData;
  notification: PushNotificationNotification;
}

interface PushNotificationState {
  pushNotification: PushNotification | null | string;
}

const initialState: PushNotificationState = {
  pushNotification: 'initial',
};

const pushNotificationSlice = createSlice({
  name: 'pushNotification',
  initialState,
  reducers: {
    setNotification(state, action) {
      // Alert.alert('set notification', JSON.stringify(action.payload));
      return {
        ...state,
        pushNotification: action.payload,
      };
    },
    clearNotification(state) {
      // Alert.alert('clear notification');
      return {
        ...state,
        pushNotification: 'cleared',
      };
    },
  },
});

export const { setNotification, clearNotification } =
  pushNotificationSlice.actions;

export const selectPushNotification = createSelector(
  (state: RootState) => state.pushNotification,
  (pushNotificationState: PushNotificationState) => {
    return {
      ...pushNotificationState,
    };
  },
);

export default pushNotificationSlice.reducer;
